var map = {
	"./characters": [
		1925
	],
	"./characters.js": [
		1925
	],
	"./languages": [
		1642
	],
	"./languages.js": [
		1642
	],
	"./the_fool": [
		3981,
		981
	],
	"./the_fool.js": [
		3981,
		981
	],
	"./the_fool_prev": [
		6509,
		509
	],
	"./the_fool_prev.js": [
		6509,
		509
	],
	"./the_hanged_man": [
		9263,
		263
	],
	"./the_hanged_man.js": [
		9263,
		263
	],
	"./the_magician": [
		1836,
		836
	],
	"./the_magician.js": [
		1836,
		836
	],
	"./the_priestess": [
		1205,
		205
	],
	"./the_priestess.js": [
		1205,
		205
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 487;
module.exports = webpackAsyncContext;